import { io } from 'socket.io-client';

let socket = null;
let currentToken = null;

export const connectSocket = (token) => {
  if (socket && currentToken === token) return socket;
  
  if (socket) {
    socket.disconnect();
  }
  
  currentToken = token;
  socket = io(process.env.REACT_APP_API_URL?.replace('/api', '') 
    || 'http://localhost:5000', {
    auth: { token },
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
  });
  return socket;
};

export const getSocket = () => socket;

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};

const socketModule = { connectSocket, getSocket, disconnectSocket };
export default socketModule;
